import React, { useContext } from 'react';
import { Form, Input, Button, Card, Typography, Space } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { AuthContext } from 'src/AuthProvider';

const { Title, } = Typography;

interface ILoginForm {
	email: string;
	password: string;
}

export default function LoginPage() {
	const [ form, ] = Form.useForm();
	const { signIn, loadingAuth, } = useContext(AuthContext);

	const onFinish = async ({ email, password, }: ILoginForm) => {
		const normalizedEmail = (email ?? '').trim().toLowerCase();
		try {
			await signIn({ email: normalizedEmail, password, });
		} catch (error: any) {
			form.resetFields([ 'password', ]);
		}
	};

	const onFinishFailed = () => {
		toast.error('Por favor, corrija os erros no formulário!');
		form.resetFields([ 'password', ]);
	};

	return (
		<div style={{ 
			display: 'flex', 
			justifyContent: 'center', 
			alignItems: 'center', 
			minHeight: '100vh',
			backgroundColor: '#f5f5f5',
		}}
		>
			<Card style={{ width: 400, boxShadow: '0 4px 8px rgba(0,0,0,0.1)', }}>
				<Space direction="vertical" size="small" style={{ width: '100%', }}>
					<div style={{ textAlign: 'center', }}>
						<Title level={3}>
                            Entrar
						</Title>
					</div>

					<Form
						form={form}
						name="login"
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						layout="vertical"
						requiredMark={false}
					>
						<Form.Item
							name="email"
							label="E-mail"
							rules={[
								{ required: true, message: 'Por favor, insira seu e-mail!', },
								{ type: 'email', message: 'E-mail inválido!', },
							]}
						>
							<Input
								prefix={<MailOutlined />}
								placeholder="Digite seu e-mail"
								size="large"
							/>
						</Form.Item>

						<Form.Item
							name="password"
							label="Senha"
							rules={[
								{ required: true, message: 'Por favor, insira sua senha!', },
								{ min: 6, message: 'Senha deve ter pelo menos 6 caracteres!', },
							]}
						>
							<Input.Password
								prefix={<LockOutlined />}
								placeholder="Digite sua senha"
								size="large"
							/>
						</Form.Item>

						<Form.Item>
							<Button 
								loading={loadingAuth}
								type="primary" 
								htmlType="submit"
								size="large"
								style={{ width: '100%', }}
							>
                                Entrar
							</Button>
						</Form.Item>
					</Form>
				</Space>
			</Card>
		</div>
	);
}